export default [
  {
    path: '/billing',
    name: 'billing',
    component: () => import(/* webpackChunkName: "billing" */ '@/views/Billing/Pages/BillingPage.vue').then(value => value.default),
    meta: {
      title: 'Billing'
    }
  }
]
